import React, { ReactElement } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

interface Props {
  isOpen: boolean;
  title: string;
  onConfirm: () => void;
  subtitle?: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
  headerText?: string;
  hideCancelButton?: boolean;
  onClose?: () => void;
  type?: "add" | "edit" | "delete" | "warning";
}

export default function ConfirmModal({
  isOpen,
  title,
  onConfirm,
  onClose,
  confirmButtonText,
  cancelButtonText,
  headerText,
  hideCancelButton,
  type,
  subtitle,
}: Props): ReactElement {
  return (
    <Modal isOpen={isOpen} toggle={onClose} className={"bg-primary"}>
      <ModalHeader toggle={onClose}>
        {headerText || "Please Confirm"}
      </ModalHeader>
      <ModalBody className="d-flex align-items-center ">
        <i
          className={`fas ${
            type === "add"
              ? "fa-folder-plus text-primary"
              : type === "delete"
              ? "fa-trash-alt text-danger"
              : type === "edit"
              ? "fa-edit text-primary"
              : type === "warning"
              ? "fa-exclamation text-primary"
              : ""
          } mx-3 fa-2x
          `}
        ></i>
        <div>
          <h3 className="my-0">{title}</h3>
          {subtitle && <span className="text-muted small">{subtitle}</span>}
        </div>
      </ModalBody>
      <ModalFooter>
        {hideCancelButton ? (
          <></>
        ) : (
          <Button color="secondary" onClick={onClose}>
            {cancelButtonText || "Cancel"}
          </Button>
        )}
        <Button
          color={type === "delete" ? "danger" : "primary"}
          onClick={onConfirm}
        >
          {confirmButtonText
            ? confirmButtonText
            : type === "delete"
            ? "Delete"
            : "Continue"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
